import { render, staticRenderFns } from "./AppSessionTimeout.vue?vue&type=template&id=3b3bc742&"
import script from "./AppSessionTimeout.vue?vue&type=script&lang=ts&"
export * from "./AppSessionTimeout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports